export default __webpack_public_path__ + "static/media/page.011795d3.png";